import 'alpinejs';
import Litepicker from 'litepicker';
import 'litepicker-module-ranges';
import snsWebSdk from '@sumsub/websdk';
import ApexCharts from 'apexcharts';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import FingerprintSaver from './fingerprint-saver';

const fingerprintSaver = new FingerprintSaver();
window.fingerprintSaver = () => fingerprintSaver.init()

window.ApexCharts = ApexCharts;
window.html2pdf = require('html2pdf.js');
window.moment = require('moment');

window.launchWebSdk = (baseUrl, accessToken, applicantEmail, lang, customCss) => {
    const snsWebSdkInstance = snsWebSdk.init(accessToken, () => this.getNewAccessToken())
        .withBaseUrl(baseUrl)
        .withConf({
            lang: lang,
            email: applicantEmail,
            uiConf: {
                customCss: customCss
            },
        })
        .onMessage((type, payload) => {
            if (type === 'idCheck.applicantStatus' && payload.reviewStatus !== 'completed') {
                if (!Array.isArray(window.dataLayer)) {
                    window.dataLayer = [];
                }

                window.dataLayer.push({ event: 'sumsubSend' });
                Livewire.emit('sumsubSend');
            }
        })
        .build();

    snsWebSdkInstance.launch('#sumsub-websdk-container')
}

window.renderChart = function(chart_id, data) {
    const locales = [
        require("apexcharts/dist/locales/en.json"),
        require("apexcharts/dist/locales/ru.json")
    ];

    data = JSON.parse(data);

    var options = {
        series: data['dataset'],
        chart: {
            fontFamily: 'system-ui',
            height: data['height'],
            type: 'line',
            locales,
            defaultLocale: data['locale'],
            toolbar: {
                show: false,
            },
        },
        tooltip: {
            enabled: true,
            style: {
                fontSize: '14px',
                fontFamily: 'system-ui',
            },
        },
        colors: [data['colors']['from'][0], data['colors']['from'][1]],
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: 'smooth',
            width: 3,
        },
        grid: {
            borderColor: '#A2B3CA',
            padding: {
                top: 0,
                left: 15,
            },
            row: {
                colors: [data['colors']['background']]
            },
        },
        xaxis: {
            categories: data['xaxis'],
            type: 'datetime',
            tickPlacement: 'between',
            crosshairs: {
                show: true,
                width: 38,
                position: 'back',
                opacity: 0.2,
                stroke: {
                    color: '#b6b6b6',
                    width: 0,
                    dashArray: 0,
                },
                fill: {
                    type: 'solid',
                    color: '#A2B3CA',
                },
                dropShadow: {
                    enabled: false,
                    top: 0,
                    left: 0,
                    blur: 1,
                    opacity: 0.4,
                },
            },
            labels: {
                show: true,
                rotate: 0,
                showDuplicates: false,
                hideOverlappingLabels: true,
                style: {
                    colors: '#859DBD',
                    fontSize: '14px',
                    fontFamily: 'system-ui',
                    fontWeight: 400,
                    cssClass: 'apexcharts-yaxis-label',
                },
                datetimeUTC: false,
                datetimeFormatter: {
                    year: 'yyyy',
                    month: 'MMM \'yy',
                    day: 'dd MMM',
                    hour: 'HH:mm'
                },
            },
        },
        yaxis: {
            tickAmount : data['tickAmount'],
            labels: {
                style: {
                    colors: ['#859DBD'],
                    fontSize: '14px',
                    fontFamily: 'system-ui',
                    fontWeight: 400,
                    cssClass: 'apexcharts-yaxis-label',
                },
                formatter: (value) => {
                    if (value == '5e-324'){ // apexChart bug (current version - 3.10.1, fixed in 3.17.0)
                        return 0;
                    } else {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' ' + data['currencySymbol'];
                    }
                },
            },
        },
        legend: {
            show: false,
            horizontalAlign: 'left',
            fontSize: '14px',
            fontFamily: 'system-ui',
            fontWeight: 500,
            offsetX: 20,
            markers: {
                width: 20,
                height: 20,
                offsetY: 50,
            },
            itemMargin: {
                horizontal: 20,
            },
            labels: {
                colors: data['colors']['text'],
            },
        },
        responsive: [
            {
                breakpoint: 1000,
                options: {
                    chart: {
                        height: '200px',
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false
                        }
                    },
                    legend: {
                        position: "bottom"
                    }
                }
            }
        ]
    };

    const chart = new ApexCharts(document.querySelector("#" + chart_id), options);
    chart.render();
}

window.animateLabel = (model) => ({
    small: true,

    isSmall(model) {
        return true;

        // let element = document.getElementById(model);

        // if (typeof element !== undefined && element !== null) {
        //     if (element.value.length){
        //         return true
        //     }
        // }

        // return false;
    },

    labelClick() {
        document.getElementById(model).focus();
    },
    focus() {
        this.small = true;
    },
    input() {
        this.small = true;
    },
    focusout() {
        // let element = document.getElementById(model);
        // if (!element.value.length){
        //     this.small = false;
        // }
    },
    checkValue() {
        setTimeout(() => {
            this.small = this.isSmall(model);
        }, 10);
    },
    resize() {
        const element = document.getElementById(model);
        element.style.height = element.scrollHeight + 'px';
    }
});

window.copyText = (id = 'link', defaultIconId = 'copy-text', successIconId = 'copy-success') => {
    let range, selection;

    const element = document.getElementById(id);
    if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
    } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
    }

    document.execCommand('copy');

    selection.removeAllRanges();

    const copySuccess = document.getElementById(successIconId);
    copySuccess.classList.remove('hide');

    const copyText = document.getElementById(defaultIconId);
    copyText.classList.add('hide');

    setTimeout(() => {
        copySuccess.classList.add("hide");
        copyText.classList.remove("hide");
    }, 2000);

}

window.autocompleteDropdown = (defaultId, defaultValue = false, options = []) => ({
    id: defaultId,
    value: defaultValue,
    input: document.getElementById('search'),
    optionsVisible: false,
    search: '',
    tmpsearch: '',
    empty: false,
    selected: {
        id: '',
        value: '',
        title: '',
    },
    options,

    filteredOptions() {
        const filteredData = this.options
            .filter(option => this.search.length > 0
                ? option.title.toLowerCase().includes(this.search.toLowerCase())
                : option.title
            );

        this.empty = filteredData.length === 0;

        return filteredData;
    },
    init() {
        if (!defaultValue) {
            return;
        }

        const selectedOption = this.options.find(option => option.value === defaultValue)

        if (selectedOption) {
            this.selectItem(selectedOption);
        }
    },
    selectItem(option) {
        this.selected = option;
        this.optionsVisible = false;
        this.search = option.title;

        const model = document.getElementById(this.id);

        if (model) {
            model.value = option.value;
            model.dispatchEvent(new Event('input'));
        }
    },
    focus() {
        if (this.optionsVisible) {
            return;
        }

        this.optionsVisible = true;

        if (this.selected.id) {
            this.tmpsearch = this.selected;
            this.search = '';
        }
    },
    focusout() {
        if (!this.optionsVisible) {
            return;
        }

        this.optionsVisible = false;

        if (this.selected.id) {
            this.search = this.selected.title;
        }
    },
});

window.datepickerComponent = (elementId, livewireContext, options) => ({
    elementId,
    livewireContext,
    options,

    inputElement: null,
    picker: null,
    livewireComponent: null,

    init() {
        this.initLivewireComponent();
        this.initInputElement();
        this.initPicker();
    },

    clearValue() {
        this.picker.clearSelection();
        this.livewireComponent.set(this.livewireContext.property, null);
    },

    initLivewireComponent() {
        this.livewireComponent = Livewire.components.findComponent(this.livewireContext.componentId);
    },

    initInputElement() {
        this.inputElement = document.getElementById(this.elementId);
    },

    initPicker() {
        this.picker = new Litepicker({
            ...this.options,
            element: this.inputElement,
            showTooltip: false,
            singleMode: true,
            onSelect: (date) => this.onPickerSelect(date),
        });
    },

    onPickerSelect() {
        this.livewireComponent.set(this.livewireContext.property, this.inputElement.value || null);
    }
});

window.startMessageTimer = () => {
    const timer = setInterval(() => {
        const span = document.getElementById('send-again-sec');
        const count = parseInt(span.innerText);

        if (count === 1) {
            Livewire.emit('canSendCodeAgain');
            clearInterval(timer);
        } else {
            span.innerText = String(count - 1);
        }

    }, 1000);
}

window.addEventListener('load', () => {
    const slider = new Swiper('.slider', {
        loop: true,
        navigation: {
            prevEl: '.usage-slider__arrow--prev',
            nextEl: '.usage-slider__arrow--next',
        },
        pagination: {
            el: '.slider-pagination',
            bulletActiveClass: 'sm:bg-blue',
            bulletClass: 'bg-gray-dark w-4 h-4 rounded-full transition-bg duration-100',
            clickable: true,
        },
    });
});
